import { AxiosResponse } from 'axios'
import { employeesApi } from '.'

import { Pagination } from '../interfaces/Pagination.interface'
import { Termination } from '../interfaces/Termination.interface'

export const getTerminations = (page?: number) => (
  employeesApi.get<Pagination<Termination>>(`/termination?page=${page || 0}`)
    .then((response: AxiosResponse) => response.data)
)

export const getTermination = (terminationId?: string) => (
  employeesApi.get<Termination>(`/termination/${terminationId}`)
    .then((response: AxiosResponse) => response.data)
)

export const createTermination = (termination: any) => (
  employeesApi.post<Termination>('/termination', termination)
    .then((response: AxiosResponse) => response.data)
)

export const updateTermination = (terminationId: string, termination: any) => (
  employeesApi.put<Termination>(`/termination/${terminationId}`, termination)
    .then((response: AxiosResponse) => response.data)
)

export const confirmTermination = (terminationId: string) => (
  employeesApi.post<Termination>(`/termination/${terminationId}/confirm`)
    .then((response: AxiosResponse) => response.data)
)

export const deleteTermination = (terminationId: string) => (
  employeesApi.delete(`/termination/${terminationId}`)
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/terminations.ts